import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreUsersAdminPatchSlice } from './patch';

export const coreUsersAdminReducers = combineReducers({
	patch: coreUsersAdminPatchSlice.asyncReducers
});

export const coreUsersAdminWatchers = combineAllWatchers([
	coreUsersAdminPatchSlice.asyncWatchers
]);
